import { type CSSProperties } from 'react';

import { VFlex } from '../VFlex';
import VBaseSelectItemCheck from './VBaseSelectItemCheck';
import { ITEM_HEIGHT } from './constant';
import style from './style';
import type { VBaseSelectItemProps } from './type';

const VBaseSelectItem = ({
  renderItem,
  onClick,
  ...item
}: VBaseSelectItemProps) => {
  return (
    <VFlex
      className={style.vBaseSelectItem(item.disabled)}
      style={
        {
          '--height': `${ITEM_HEIGHT}px`,
        } as CSSProperties
      }
      gap={0.25}
      items="center"
      role="option"
      onClick={() => !item.disabled && onClick(item)}
      aria-selected={item.selected}
    >
      {typeof renderItem === 'function' ? (
        renderItem({
          item,
          selected: item.selected ?? false,
          Check: VBaseSelectItemCheck,
        })
      ) : (
        <>
          <VBaseSelectItemCheck label={item.label} selected={item.selected} />
          <div role="presentation" className={style.vBaseSelectItemLabel}>
            {item.label}
          </div>
        </>
      )}
    </VFlex>
  );
};

export default VBaseSelectItem;
